// frontend/src/components/Samples/SampleOrderTypes.jsx

import React from 'react';
import { sampleOrderTypesAPI } from '../../api/client';
import { useTranslation } from '../../context/TranslationContext';
import MasterDataManager from '../Common/MasterDataManager';

const SampleOrderTypes = () => {
  const { t } = useTranslation();

  const columns = [
    {
      header: t('sample_order_types.type', 'Order Type'),
      field: 'sample_order_type',
      className: 'code-column'
    },
    {
      header: t('sample_order_types.sequence', 'Sequence'),
      field: 'sequence',
      className: 'text-center'
    },    
    {
      header: t('sample_order_types.category', 'Category'),
      field: 'category',
      className: 'text-center'
    },
    {
      header: t('sample_order_types.description', 'Description'),
      field: 'description'
    },
    {
      header: t('created_at', 'Created'),
      field: 'created_at',
      render: (row) => new Date(row.created_at).toLocaleDateString(),
      sortable: false
    }
  ];

  const formFields = [
    {
      name: 'category',
      label: 'sample_order_types.category',
      type: 'text',
      required: true,
      maxLength: 20
    },
    {
      name: 'sequence',
      label: 'sample_order_types.sequence',
      type: 'number',
      required: true
    },
    {
      name: 'sampleOrderType',
      label: 'sample_order_types.type',
      type: 'text',
      required: true,
      maxLength: 20
    },
    {
      name: 'description',
      label: 'sample_order_types.description',
      type: 'text',
      maxLength: 50
    },
    {
      name: 'notes',
      label: 'notes',
      type: 'textarea',
      rows: 3
    }
  ];

  return (
    <MasterDataManager
      title="sample_order_types.title"
      subtitle="sample_order_types.subtitle"
      createButtonLabel="sample_order_types.create"
      api={sampleOrderTypesAPI}
      columns={columns}
      formFields={formFields}
      idField="sample_order_type_id"
      displayField="sample_order_type"
    />
  );
};

export default SampleOrderTypes;